export default {"src":"/_next/static/media/assistant-nurse.4b53514a.svg","height":272,"width":260};